import { SessionStore } from './session-store';
import { randomId, randomString } from '../util/strings';

export interface ITransactionManager {
    createTransaction: (nonce?: string) => [state: string, nonce: string];
    getTransaction: (state?: string | null) => [state: string, nonce: string] | [null, null];
}

export const TransactionManager: ITransactionManager = (() => {
    const storageKey = 'transaction';

    const getStates = (): { state: string, nonce: string }[] => {
        const sessionValue = SessionStore.get(storageKey);
        const parsed = JSON.parse(sessionValue || '[]');
        if (!Array.isArray(parsed)) {
            return [];
        }
        return parsed;
    };

    const pushState = (nonce: string, state: string) => {
        const mapping = [ ...getStates(), { state, nonce } ];
        SessionStore.put(storageKey, JSON.stringify(mapping));
    };

    return {
        createTransaction: (nonce) => {
            const _state = randomId(20);
            const _nonce = nonce || randomString(20);
            pushState(_nonce, _state);
            return [ _state, _nonce ];
        },
        getTransaction: (state = null) => {
            const mapping = getStates();
            if (state) {
                const match = mapping.find(m => m.state === state);
                if (match) {
                    return [ match.state, match.nonce ];
                }
            }
            if (mapping.length > 0) {
                const match = mapping[mapping.length - 1];
                return [ match.state, match.nonce ];
            }
            return [ null, null ];
        },
    };
})();
